import vueFilePond from "vue-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

export default {
    install: (app, options) => {

        const optionsDefaults = {
        };

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        // Create component
        const FilePond = vueFilePond(
            FilePondPluginImagePreview
        );

        // Register component
        app.component('FilePond', FilePond)
    }
}